import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPlacements } from 'core/actions/ocapi';

import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';

import StickyFooterMobile from './components/StickyFooterMobile/StickyFooterMobile';
import StickyFooterDesktop from './components/StickyFooterDesktop/StickyFooterDesktop';

import {
  selectStickyFooterConfig, selectStickyFooterIsLoaded,
  selectStickyFooterIsLoading, selectStickyFooterPlacement,
} from './selectors';

export function StickyFooter() {
  const isMobileMQ = useSelector(selectIsMobileMQ);
  const config = useSelector(selectStickyFooterConfig);
  const isLoading = useSelector(selectStickyFooterIsLoading);
  const isLoaded = useSelector(selectStickyFooterIsLoaded);
  const placement = useSelector(selectStickyFooterPlacement);
  const dispatch = useDispatch();

  useEffect(() => {
    const { api: { contentParams, otherParams, options } } = config;

    contentParams.forEach((contentParamsSet) => {
      const { content_group_id: namespaceId } = contentParamsSet;

      if (!isLoaded[namespaceId] && !isLoading[namespaceId]) {
        const params = { ...contentParamsSet, ...otherParams };
        dispatch(fetchPlacements(params, { ...options, namespace: namespaceId }));
      }
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    isMobileMQ
      ? <StickyFooterMobile placement={placement} config={config} />
      : <StickyFooterDesktop placement={placement} config={config} />
  );
}

export default (props) => <ComponentErrorBoundary><StickyFooter {...props} /></ComponentErrorBoundary>;
